import React, { useState, useEffect } from 'react';

const ImageModal = ({ imageURL = 'https://res.cloudinary.com/dhhztw6hx/image/upload/v1778254603/gpngzcmsih0xqh0eqwwh.jpg', onClose }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    if (onClose) onClose();
  };
  const handleShow = () => setShowModal(true);

  // Automatically show the modal when the component mounts and imageURL is provided
useEffect(() => {
  if (!imageURL) return;

  const expiryDate = new Date("2026-06-11T00:00:00");
  const today = new Date();

  if (today < expiryDate) {
    handleShow(); // Open modal only till 1 May 2026
  }
}, [imageURL]);

  return (
    <div>
      {/* Button is optional now as the modal will open automatically */}
      {/* <button 
        type="button" 
        className="btn btn-primary" 
        onClick={handleShow}
      >
        Launch demo modal
      </button> */}

      {showModal && imageURL && (
        <div 
          className="modal fade show" 
          id="exampleModalCenter" 
          tabindex="-1" 
          role="dialog" 
          aria-labelledby="exampleModalCenterTitle" 
          aria-hidden="true"
          style={{ display: 'block' }}
        >
          <div className="mx-auto modal-dialog"  style={{maxWidth: 'fit-content', marginTop: '4rem', padding:'1rem'}} role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={handleClose} 
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center">
                <img
                  src={imageURL}
                  alt="Full screen" 
                  className="img-fluid" 
                  style={{ maxHeight: '80vh' }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageModal;
